// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ArticleListSection_pagination_1dtSq","spinAround":"ArticleListSection_spinAround_1u9-i"};